import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

function UserItem({ user: { login, avatar_url } }) {
  // NOTE: check for valid url to users website
  return (
    <div className='card shadow-md compact side bg-base-300'>
      <div className='flex-row items-center space-x-4 card-body'>
        <div>
          <div className='avatar'>
            <div className='rounded-full shadow w-14 h-14'>
              <img src={avatar_url} alt='Profile' />
            </div>
          </div>
        </div>
        <div>
          <h2 className='card-title'>{login}</h2>
          <Link
            className='link link-accent no-underline'
            to={`/user/${login}`}
          >
            Visit Profile
          </Link>
        </div>
      </div>
    </div>
  ) // NOTE: check for valid url to users website
}

UserItem.propTypes = {
  user: PropTypes.object.isRequired,
}

export default UserItem